export default __webpack_public_path__ + "static/media/15.416e4a24.png";